import aihero from "../../images/services/ai-hero.webp";
import webapphero from "../../images/services/web-app-hero.webp";
import blockchainhero from "../../images/services/blockchain-hero.webp";
import cloudhero from "../../images/services/cloud-hero.webp";
import robotichero from "../../images/services/rpa-hero.webp";
import devopshero from "../../images/services/business-intelligence-hero.webp";
import mlhero from "../../images/services/ml-hero.webp";
import androidhero from "../../images/services/android-hero.webp";
import iothero from "../../images/services/iot-hero.webp";
import ioshero from "../../images/services/ios-hero.webp";

import aiList from "../../images/services/ai-list-icons.webp";
import webappList from "../../images/services/web-list-icons.webp";
import blockchainList from "../../images/services/blockchain-list-icons.webp";
import cloudList from "../../images/services/cloud-list-icons.webp";
import roboticList from "../../images/services/robotic-list-icons.webp";
import devopsList from "../../images/services/devops-list-icons.webp";
import mlList from "../../images/services/ml-list-icons.webp";
import androidList from "../../images/services/android-list-icons.webp";
import iotList from "../../images/services/iot-list-icons.webp";
import iosList from "../../images/services/ios-list-icons.webp";

export const serviceImages = {
  ai: {
    hero: aihero,
    list: aiList,
  },
  webapp: {
    hero: webapphero,
    list: webappList,
  },
  blockchain: {
    hero: blockchainhero,
    list: blockchainList,
  },
  cloud: {
    hero: cloudhero,
    list: cloudList,
  },
  robotic: {
    hero: robotichero,
    list: roboticList,
  },
  devops: {
    hero: devopshero,
    list: devopsList,
  },
  ml: {
    hero: mlhero,
    list: mlList,
  },
  android: {
    hero: androidhero,
    list: androidList,
  },
  iot: {
    hero: iothero,
    list: iotList,
  },
  ios: {
    hero: ioshero,
    list: iosList,
  },
};
